import fileDownloadBase from 'js-file-download';

export const fileDownload = (file: Blob, meta: { fileName: string; mime: string } | { [key: string]: string }) => {
  const fileName = meta?.fileName ?? getFileName(meta);
  const mime = meta?.mime ?? getContentType(meta);

  fileDownloadBase(file, fileName, mime);
};

export const getContentType = (headers: { [key: string]: string }) => headers['content-type'] ?? '';
export const getFileName = (headers: { [key: string]: string }) => {
  const disposition = headers['content-disposition'];
  var matches = disposition
    ? disposition
        .split(/filename=|filename\*=.+''/)
        .splice(1)
        .map((name: string) => name.trim().replace(/^["']|[;"']{0,2}$/g, ''))
        .filter((name: string) => name.length)
    : [];
  return matches.length ? decodeURI(matches[matches.length - 1]) : '';
};
